<template>
  <div>
    <Top></Top>
    <div class="main">
      <img src="../../assets/img/options.jpg" alt="" />
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Top from "../../components/head/Top";
import Foot from "../../components/foot/Foot";
export default {
  data() {
    return {
      datas: `<h2>オプション代金</h2>
      <ul>
        <li class="flex2">オプション内容</li>
        <li>単価</li>
        <li class="flex3">操作内容</li>
        <li>before</li>
        <li style="border-right: 1px solid #eee">after</li>
      </ul>
      <!-- <ul>
        <li class="flex2">アマゾンFBA等用ラベル貼</li>
        <li>1元/枚</li>
        <li class="flex3 hg">
          <p>（PDF をお送り頂き、</p>
          <p>弊社でプリントアウトし貼付＆ＯＰＰ無料交換）</p>
          <p>A4判 24面(33.9mm x 66.0mm)</p>
        </li>
        <li>
          <img src="../../assets/img/1-1.png" alt />
        </li>
        <li style="border-right:1PX solid #eee">
          <img src="../../assets/img/1-2.png" alt />
        </li>
      </ul> -->
      <ul>
        <li class="flex2">OPP袋取り替え</li>
        <li>無料</li>
        <li class="flex3">大型商品は別途相談</li>
        <li>
          <img src="../../assets/img/2-1.png" alt />
        </li>
        <li style="border-right: 1px solid #eee">
          <img src="../../assets/img/2-2.png" alt />
        </li>
      </ul>
      <ul>
        <li class="flex2">印刷物印刷封入</li>
        <li>1元/1枚</li>
        <li class="flex3">カラープリント2元/枚</li>
        <li>
          <img src="../../assets/img/3-1.png" alt />
        </li>
        <li style="border-right: 1px solid #eee">
          <img src="../../assets/img/3-2.png" alt />
        </li>
      </ul>
      <ul>
        <li class="flex2">織タグ交換</li>
        <li>3元/枚</li>
        <li class="flex3"></li>
        <li>
          <img src="../../assets/img/4-1.png" alt />
        </li>
        <li style="border-right: 1px solid #eee">
          <img src="../../assets/img/4-2.png" alt />
        </li>
      </ul>
      <!-- <ul>
        <li class="flex2">織ネーム取り外し</li>
        <li>1.5元/1枚</li>
        <li class="flex3"></li>
        <li>
          <img src="../../assets/img/5-1.png" alt />
        </li>
        <li style="border-right:1PX solid #eee">
          <img src="../../assets/img/5-2.png" alt />
        </li>
      </ul> -->
      <ul>
        <li class="flex2">下げ札交換</li>
        <li>1元/枚</li>
        <li class="flex3"></li>
        <li>
          <img src="../../assets/img/6-1.png" alt />
        </li>
        <li style="border-right: 1px solid #eee">
          <img src="../../assets/img/6-2.png" alt />
        </li>
      </ul>
      <!-- <ul>
        <li class="flex2">下げ札取り外し</li>
        <li>1元/1枚</li>
        <li class="flex3"></li>
        <li>
          <img src="../../assets/img/7-1.png" alt />
        </li>
        <li style="border-right:1PX solid #eee">
          <img src="../../assets/img/7-2.png" alt />
        </li>
      </ul>-->
      <ul>
        <li class="flex2">セット組（三種類まで）</li>
        <li>1元/枚</li>
        <li class="flex3">（四種以上商品のセットの手数料は事前に相談）</li>
        <li>
          <img src="../../assets/img/8-1.png" alt />
        </li>
        <li style="border-right: 1px solid #eee">
          <img src="../../assets/img/8-2.png" alt />
        </li>
      </ul>
      <ul>
        <li class="flex2">緩衝材梱包（プチプチ梱包）</li>
        <li>1元/個</li>
        <li class="flex3">大型商品の場合、別途相談</li>
        <li>
          <img src="../../assets/img/9-1.png" alt />
        </li>
        <li style="border-right: 1px solid #eee">
          <img src="../../assets/img/9-2.png" alt />
        </li>
      </ul>
      <h3>検品について</h3>
      <!-- <div class="content">
        <div class="fl img">
          <img src="../../assets/img/des1.png" alt />
        </div>
        <div class="fl txt">
          <h3>簡易（無料）検品</h3>
          <p>全ての入荷商品に対して、</p>
          <p>簡易検品を行っています。</p>
          <h6>★注文通りの納品かどうか</h6>
          <h6>★外観のダメージ有無</h6>
          <h6>★商品ページの商品と大きな乖離がないか</h6>
          <p>主に上記３点になります。</p>
          <p>問題があれば、お客様に報告して返品・返金交渉を無料で行います。</p>
          <h6>※店舗より返品送料負担しない場合があります</h6>
        </div>
      </div> -->
      <div class="content" style="margin-bottom: 0">
        <div class="fl img">
          <img src="../../assets/img/des2.png" alt />
        </div>
        <div class="fl txt">
          <h3>アパレル商品すべて詳細検品させていただきます</h3>
          <p>問題があれば、お客様に報告して返品・返金交渉を無料で行います</p>
          <p>
            ※店舗より返品送料負担しない場合や返品対応しない場合がありますので、
          </p>
          <p>その場合はお客様負担になります。</p>
          <!-- <p>利用料は商品金額の６％となります。※（一部例外有り）</p>
          <p>問題があれば、お客様に報告して返品・返金交渉を無料で行います。</p>
          <h6>※店舗より返品送料負担しない場合があります。</h6> -->
        </div>
      </div>
      <h3>紙や織タグの制作費について</h3>
      <p class="p">
        デザインやサイズにより値段が違いますので、その都度お問い合わせください。
      </p>
      <ol>
        <li>
          <p>紙タグサンプル写真</p>
          <img src="../../assets/img/xiezhen10.png" alt />
        </li>
        <li>
          <p>織タグサンプル写真</p>
          <img src="../../assets/img/xiezhen11.png" alt />
        </li>
        <li>
          <p>品質タグサンプル写真</p>
          <img src="../../assets/img/xiezhen12.png" alt />
        </li>
        <li>
          <p>品質カードサンプル写真</p>
          <img src="../../assets/img/xiezhen13.png" alt />
        </li>
      </ol>
      <h5>
        ＊オプション料金はのは基本上記の金額で作業費込みの価格になります、商品によって特別料金になる場合もござい
      </h5>
      <h5>ます、その都度事前に後報告させて頂きます</h5>`,
    };
  },
  components: {
    Top,
    Foot,
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
.main {
  width: 1200px;
  margin: 0 auto 50px;
  img {
    width: 1200px;
    padding: 30px;
  }
  h2 {
    text-align: center;
    font-size: 36px;
    font-weight: 700;
    margin: 120px 0 80px;
  }
  ul {
    display: flex;
    height: 95px;
    line-height: 95px;
    margin-bottom: 5px;
    li {
      flex: 1;
      text-align: center;
      float: left;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
      font-size: 18px;
      img {
        margin-top: 15px;
        width: 100px;
        height: 67px;
      }
    }
    .flex2 {
      flex: 2;
      background: #d4e1ff;
      border: 0;
    }
    .flex3 {
      flex: 3;
    }
    .hg {
      padding: 15px 5px 0;
      p {
        line-height: 25px;
      }
    }
  }
  h3 {
    text-align: center;
    font-size: 22px;
    font-weight: 700;
    margin: 80px 0 30px;
  }
  .content {
    overflow: hidden;
    margin-bottom: 100px;
    .img {
      width: 220px;
      height: 220px;
      margin-right: 80px;
      img {
        width: 220px;
        height: 220px;
      }
    }
    .txt {
      font-size: 14px;
      h3 {
        margin: 0 0 15px;
        text-align: left;
      }
      p {
        line-height: 25px;
      }
      h6 {
        color: #f3c622;
      }
    }
  }
  .p {
    text-align: center;
    margin-bottom: 50px;
  }
  ol {
    display: flex;
    margin-bottom: 40px;
    li {
      flex: 1;
      text-align: center;
      p {
        font-size: 18px;
      }
      img {
        width: 170px;
        height: 142px;
      }
    }
  }
  h5 {
    color: #f3c622;
    text-indent: 5em;
    line-height: 30px;
    font-size: 18px;
  }
}
</style>